import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomTextField from "../formControls/CustomTextField";
import { useForm } from "react-hook-form";
import { RendererType } from "../../types/enums/enums";
import { CirclePlusIcon, LongRightArrow } from "../Icons";
import BasicSelect from "../formControls/Select";

const AddForm = () => {
  const conversionAddForm = useForm<any>();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = conversionAddForm;

  const FormFiledOptions = [
    {
      title: "Campaign",
    },
    {
      title: "Conversions",
    },
    {
      title: "Reports",
    },
  ];

  return (
    <Box className="bg-white flex-column w-full lg:w-[80%] rounded-[20px] border border-primary-blue-100">
      {/* header */}
      <Box className="p-5 flex justify-between items-center gap-[2px] border-b border-b-primary-blue-100 ">
        <Typography className="!text-xl !font-medium">Add Form</Typography>
        <Button
          onClick={() => ""}
          className="!gap-[5px] !cursor-pointer !rounded-lg !px-[20px] !py-[8px] !bg-primary-blue-950 flex-center !text-white"
        >
          <Typography className="!text-sm !font-normal !text-white  !normal-case">
            Save
          </Typography>
        </Button>
      </Box>

      <Box className="flex-column gap-[25px] px-20 py-5">
        <CustomTextField
          label=""
          name="form_url"
          placeholder="Enter Form URL"
          type={RendererType.string}
          control={control}
        />
        <CustomTextField
          label=""
          name="form_name"
          placeholder="Enter Form Name"
          type={RendererType.string}
          control={control}
        />
      </Box>

      <Box className="flex flex-col px-20 py-5 gap-[10px]">
        <Box className="flex w-full ">
          <Box className="w-1/2">
            <Typography className="!text-sm !font-normal !text-black  !normal-case">
              Form Field
            </Typography>
          </Box>
          {/* <span /> */}
          <Box className="w-1/2">
            <Typography className="!text-sm !font-normal !text-black  !normal-case">
              Platform Field
            </Typography>
          </Box>
        </Box>

        {/* Dynamic */}
        <Box className="flex justify- w-full">
          <Box className="w-[50%]">
            <CustomTextField
              label=""
              name="first_name"
              placeholder="Enter First Name"
              type={RendererType.string}
              control={control}
              errors={errors.first_name?.message?.toString()}
              rules={{
                required: "First Name is Required",
              }}
            />
          </Box>
          <span className="flex justify-center items-center w-[10%] mx-2">
            {LongRightArrow}
          </span>
          <Box className="flex items-center gap- justify-between w-2/3">
            <Box className="w-3/4">
              <CustomTextField
                label=""
                name="first_name"
                placeholder="Enter First Name"
                type={RendererType.string}
                control={control}
                errors={errors.first_name?.message?.toString()}
                rules={{
                  required: "First Name is Required",
                }}
              />
            </Box>
            <Box onClick={() => ""} className="w-[10%] cursor-pointer">
              {CirclePlusIcon}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AddForm;
